import React from 'react';
import { useInput, useTranslate } from 'react-admin';
import { FormControl, FormHelperText } from '@material-ui/core';
import { AceScriptEditor } from '~/components';

interface AceEditorInputProps {
  source: string;
  validate?: any;
  defaultValue?: any;
  placeholder?: string;
  [key: string]: any;
}

function AceEditorInput(props: AceEditorInputProps) {
  const { source, validate, defaultValue, placeholder, ...rest } = props;
  const all = useInput({
    source,
    validate,
    defaultValue,
    ...rest,
  });

  const translate = useTranslate();

  const { input: field, meta } = all;
  const { error, touched, invalid } = meta ?? {};
  const showError = touched && invalid;

  const handleEditorChange = (newValue: string) => {
    field?.onChange(newValue);
  };
  const handleEditorBlur = () => {
    field?.onBlur();
  };

  return (
    <FormControl fullWidth error={showError} margin='dense'>
      <AceScriptEditor
        name={field?.name}
        value={field?.value || ''}
        onChange={handleEditorChange}
        onBlur={handleEditorBlur}
        placeholder={placeholder}
      />
      <FormHelperText error>{showError ? translate(error) : ' '}</FormHelperText>
    </FormControl>
  );
}

export default AceEditorInput;
